import { Component } from 'react';
import HabitDatesModule from './HabitDatesModule';
import Habit from '../models/habit';
import { makeBEM } from '../global/utils';
import { BUTTON_TITLES, UTILITY_CSS_CLASSES } from '../global/constants';
import { FormReveal, RevealAnimation } from './Animations';
import HabitForm from '../forms/HabitForm';
import HabitController from "../controllers/HabitController";
import { GeneralObserver } from './Observer';
import Icon from '../atoms/Icon';

class HabitModule extends Component {
	constructor(props) {
		super(props);

		this.state = {
			controller: new HabitController(this.props.data),
			habit: this.props.data,
			buttonActions: [],
			animate: this.props.animate,
			editMode: false,
			deleteAction: this.props.deleteAction ? this.props.deleteAction : false,
			isSubmitting: false,
		};

		this.moduleName = 'habit';
		this.bindFunctions();
	}

	// Binds functions to instance
	bindFunctions() {
		this.toggleEditMode = this.toggleEditMode.bind(this);
		this.reactFn = this.reactFn.bind(this);
	}

	componentDidMount() {
		this.initialSetup();
	}

	componentDidUpdate(prevProps) {
		if ( this.props.data !== prevProps.data ) {
			this.handlePropChange();
		}
	}

	handlePropChange() {
		const ctrl = this.state.controller;
		ctrl.setHabit(this.props.data);
		this.setState(({
			controller: ctrl,
		}));
	}

	// Setup observer and subscribe to events from controller
    // Fetch data from controller 
	initialSetup() {
		const ctrl = this.state.controller;
		this.observer = new GeneralObserver(this.reactFn);
		ctrl.addObserver(this.observer);

		this.setState({
			controller: ctrl
		});
	}

	// Reacts to controller events
	// Sets controller and habit
	reactFn() {
		const ctrl = this.state.controller;
		const habit = ctrl.getHabit();

		this.setState({
			controller: ctrl,
			habit: habit
		});
	}

	// Event handler for mark today btn
	// Calls ctrl markStreak fn
	buttonActionMarkToday = () => {
		const ctrl = this.state.controller;
		ctrl.markStreak();
		
	}

	// Toggles edit mode by negating editMode state
	toggleEditMode() {
        this.setState({
            editMode: !this.state.editMode
        })
    }

	// Renders done button
	renderDoneButton(habit) {
		let buttonText = BUTTON_TITLES.today;
		const isSubmitting = this.state.isSubmitting;
		
		if ( habit.streakDates.length === 0 ) {
			buttonText = BUTTON_TITLES.startToday;
		}

		const className = `btn--icon-and-text ${makeBEM(this.moduleName, 'streak-btn')}`;

		return (
			<div className="module__btn-wrapper">
				<button 
					className={className} 
					onClick={this.buttonActionMarkToday}
					disabled={isSubmitting}
				>
					<Icon name="check" size="2"/>{ buttonText }
				</button>
			</div>
		)
	}

	// Renders habit content
	renderContent(habit) {
		return (
			<div className={this.moduleName}>
				<p className={ makeBEM(this.moduleName, 'title-and-days-done-wrapper') }> 
					<span 
						className={ `${makeBEM(this.moduleName, 'title')} ${UTILITY_CSS_CLASSES.hasAction}` } 
						onDoubleClick={this.toggleEditMode}
					>{habit.getTitle()}</span>
					<span className={ makeBEM(this.moduleName, 'days-done') }>
						<span className={ makeBEM(this.moduleName, 'current-streak') }>{habit.getCurrentStreak()}</span> / {habit.getDurationDays()}
					</span>
				</p> 
				{ 
					<HabitDatesModule
						dates={habit.getStreakDates()}
						parentID={habit.getId()}
					/>
				}
				{
					!habit.getUpdatedToday() ?
					this.renderDoneButton(habit) :
					''
				}
			</div>
		)
	}

	render() {
		const ctrl = this.state.controller;
		if ( !ctrl ) {
			return false;
		}

		const habit = ctrl.getHabit();
		const animate = this.state.animate;
		const editMode = this.state.editMode;
		const editModeClass = editMode ? UTILITY_CSS_CLASSES.editing : '';
		const wrapperClass =  makeBEM(this.moduleName, 'wrapper');
		const deleteAction = this.state.deleteAction;

		return (
			habit ? 
			<div className={`${wrapperClass} ${editModeClass}`}>
				{
					animate ?
					<RevealAnimation key={habit.id} direction='down'>
						{ this.renderContent(habit) }
					</RevealAnimation>
					: this.renderContent(habit)
				}
				{
					editMode && 
					<FormReveal>
						<HabitForm
							className={ makeBEM(this.moduleName, 'edit-form') }
							habit={habit.toFormObject()}
							discardForm={this.toggleEditMode}
							deleteSuccess={deleteAction}
							controller={ctrl}
						/>
					</FormReveal>
				}
			
	    	</div>
			: ''
		)
	}
}

export default HabitModule;